import React from 'react';
import ReactDOM from 'react-dom';

import events from 'events.js';

import {
    PracticeStoreContext,
    PracticeGroupStoreContext,
} from 'core/stores/RootStore.js';
import PracticeApp from 'practices/components/PracticeApp.js';
import {snakeToCamelObjectKeys} from 'utils/case_converter.js';

(async function () {
    await events.ready();
    const practiceSection = document.getElementById('practice-group');
    const props = snakeToCamelObjectKeys(
        JSON.parse(practiceSection.dataset.practice),
    );

    ReactDOM.render(
        <PracticeStoreContext.Provider value={PracticeGroupStoreContext}>
            <PracticeApp {...props} />
        </PracticeStoreContext.Provider>,
        practiceSection,
    );
})();
